var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgError = function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4106_17098)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8811 14.0032L21.6526 9.2317C22.0485 8.85665 22.2777 8.33574 22.2777 7.75232C22.2771 7.33979 22.1544 6.93667 21.9252 6.59374C21.6959 6.2508 21.3702 5.9834 20.9892 5.82521C20.6082 5.66702 20.189 5.62512 19.7842 5.7048C19.3794 5.78447 19.0073 5.98215 18.7147 6.27294L13.9432 11.0653L9.17164 6.27294C8.77928 5.88058 8.24714 5.66016 7.69226 5.66016C7.13738 5.66016 6.60523 5.88058 6.21288 6.27294C5.82052 6.66529 5.6001 7.19744 5.6001 7.75232C5.6001 8.30719 5.82052 8.83934 6.21288 9.2317L11.0052 14.0032L6.23371 18.7748C5.83782 19.1498 5.60862 19.6707 5.60862 20.2541C5.60922 20.6667 5.73189 21.0698 5.96118 21.4127C6.19047 21.7557 6.51612 22.0231 6.89711 22.1812C7.2781 22.3394 7.69739 22.3813 8.10214 22.3017C8.5069 22.222 8.87903 22.0243 9.17164 21.7335L13.9432 16.9412L18.7147 21.7127C19.0898 22.1086 19.6107 22.3378 20.1941 22.3378C20.6066 22.3372 21.0097 22.2145 21.3527 21.9852C21.6956 21.7559 21.963 21.4303 22.1212 21.0493C22.2794 20.6683 22.3213 20.249 22.2416 19.8443C22.1619 19.4395 21.9642 19.0674 21.6735 18.7748L16.8811 14.0032Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4106_17098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
};
export default SvgError;